<div id='appointment-summary'>
  <app-confirmation class="app-confirmation"
                    [view]="view"
                    [detailMap]="detailMap$ | async"
                    [carImage]="imageUrl$ | async"
                    [makeModelYear]="makeModelYear$ | async">
  </app-confirmation>
</div>
